export class PayGroup {
    Grp;
    GrpDesc;
    PayTypeCode;
    PayMethodCode;
    StartDay;
    ValueDay;
    constructor() {
        {
            this.Grp = "";
            this.GrpDesc = "";
            this.PayTypeCode = "";
            this.PayMethodCode = "";
            this.StartDay = 1;
            this.ValueDay = 1
        }
    }
}



// WEBPACK FOOTER //
// ./src/model/PayGroup.js